import { PanelGridRowDropZone } from './PanelGridRowDropZone';

interface PanelGridLayoutProps {
  readonly rowCount?: number;
}

export const PanelGridLayout = ({ rowCount = 1 }: PanelGridLayoutProps) => {
  const rowNumbers = Array.from({ length: rowCount }, (_, index) => index + 1);

  return (
    <div data-testid="panel-grid-layout">
      {rowNumbers.map((rowNumber) => (
        <div key={`panel-grid-row-${rowNumber}`} style={{ marginTop: rowNumber === 1 ? 0 : 16 }}>
          <PanelGridRowDropZone rowIndex={rowNumber} />
        </div>
      ))}
    </div>
  );
};
